import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Collapse
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import FolderIcon from "@mui/icons-material/Folder";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

import EventNoteIcon from "@mui/icons-material/EventNote";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // ⭐ ADDED
import AccountTreeIcon from "@mui/icons-material/AccountTree"; // ⭐ ADDED

import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";

import { useAuth } from "../../context/AuthContext";
import { canManageUsers } from "../../utils/roles";

export default function Sidebar() {

  const { user } = useAuth();

  const [openHRMS, setOpenHRMS] = useState(false);

  const [openBilling, setOpenBilling] = useState(false);

  // ⭐ ADDED STATE FOR ACCOUNTING SECTION
  const [openAccounting, setOpenAccounting] = useState(false);

  const navigate = useNavigate();

  const toggleHRMS = () => {

    setOpenHRMS(!openHRMS);

    navigate("/leaves/overview");
  };

  const toggleBilling = () => {

    setOpenBilling(!openBilling);

    navigate("/billing/overview");
  };

  // ⭐ ADDED ACCOUNTING TOGGLE
  const toggleAccounting = () => {

    setOpenAccounting(!openAccounting);

    navigate("/accounting/dashboard");
  };

  const menu = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/" },
    { text: "Projects", icon: <FolderIcon />, path: "/projects" },

    ...(canManageUsers(user?.role)
      ? [{ text: "People", icon: <PeopleIcon />, path: "/people" }]
      : []),

    { text: "Reports", icon: <AssessmentIcon />, path: "/reports" },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        "& .MuiDrawer-paper": {
          width: 240,
          background: "#0F172A",
          color: "#fff",
          borderRight: "none"
        }
      }}
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight="bold">
          Lekhani PMS
        </Typography>
      </Box>

      <List>

        {/* ===============================
            MAIN MENU
        =============================== */}

        {menu.map((item) => (
          <ListItemButton
            key={item.text}
            component={NavLink}
            to={item.path}
            sx={{
              mx: 1,
              mb: 1,
              borderRadius: 3,
              color: "#cbd5e1",

              "&.active": {
                background: "linear-gradient(135deg,#6366F1,#8B5CF6)",
                color: "#fff"
              },

              "&:hover": {
                background: "rgba(255,255,255,0.08)"
              }
            }}
          >
            <ListItemIcon sx={{ color: "inherit" }}>
              {item.icon}
            </ListItemIcon>

            <ListItemText primary={item.text} />
          </ListItemButton>
        ))}

        {/* ===============================
            BILLING SECTION
        =============================== */}

        {(user?.role === "ADMIN" || user?.role === "HR") && (
          <>
            <ListItemButton onClick={toggleBilling} sx={{ mx: 1, mt: 2 }}>
              <ListItemIcon sx={{ color: "#cbd5e1" }}>
                <AttachMoneyIcon />
              </ListItemIcon>

              <ListItemText primary="Billing" />

              {openBilling ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openBilling} timeout="auto" unmountOnExit>

              <List component="div" disablePadding>

                <ListItemButton component={NavLink} to="/billing/overview" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Billing Overview" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/billing/clients" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Clients" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/billing/effort-summary" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <ReceiptLongIcon />
                  </ListItemIcon>
                  <ListItemText primary="Effort Summary" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/billing/rate-maintenance" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Rate Maintenance" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/billing/project-billing" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <ReceiptLongIcon />
                  </ListItemIcon>
                  <ListItemText primary="Project Billing" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/billing/invoices" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <RequestQuoteIcon />
                  </ListItemIcon>
                  <ListItemText primary="Invoices" />
                </ListItemButton>

              </List>

            </Collapse>
          </>
        )}

        {/* ===============================
            ⭐ ACCOUNTING SECTION (NEW)
        =============================== */}

        {(user?.role === "ADMIN" || user?.role === "HR") && (
          <>
            <ListItemButton onClick={toggleAccounting} sx={{ mx: 1, mt: 2 }}>

              <ListItemIcon sx={{ color: "#cbd5e1" }}>
                <AccountBalanceIcon />
              </ListItemIcon>

              <ListItemText primary="Accounting" />

              {openAccounting ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openAccounting} timeout="auto" unmountOnExit>

              <List component="div" disablePadding>

                <ListItemButton component={NavLink} to="/accounting/dashboard" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/receivables" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Receivables" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/payables" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <ReceiptLongIcon />
                  </ListItemIcon>
                  <ListItemText primary="Payables" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/expenses" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <ReceiptLongIcon />
                  </ListItemIcon>
                  <ListItemText primary="Expenses" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/payments" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Payments" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/accounts" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <AccountTreeIcon />
                  </ListItemIcon>
                  <ListItemText primary="Chart of Accounts" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/accounting/reports" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <AssessmentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reports" />
                </ListItemButton>

              </List>

            </Collapse>
          </>
        )}

        {/* ===============================
            HRMS SECTION
        =============================== */}

        <ListItemButton onClick={toggleHRMS} sx={{ mx: 1, mt: 2 }}>

          <ListItemIcon sx={{ color: "#cbd5e1" }}>
            <BusinessCenterIcon />
          </ListItemIcon>

          <ListItemText primary="HRMS" />

          {openHRMS ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openHRMS} timeout="auto" unmountOnExit>

          <List component="div" disablePadding>

            <ListItemButton component={NavLink} to="/leaves/overview" sx={{ pl: 6 }}>
              <ListItemIcon sx={{ color: "inherit" }}>
                <EventAvailableIcon />
              </ListItemIcon>
              <ListItemText primary="Leave Overview" />
            </ListItemButton>

            <ListItemButton component={NavLink} to="/leaves/apply" sx={{ pl: 6 }}>
              <ListItemIcon sx={{ color: "inherit" }}>
                <EventNoteIcon />
              </ListItemIcon>
              <ListItemText primary="Apply Leave" />
            </ListItemButton>

            <ListItemButton component={NavLink} to="/leaves/statement" sx={{ pl: 6 }}>
              <ListItemIcon sx={{ color: "inherit" }}>
                <EventBusyIcon />
              </ListItemIcon>
              <ListItemText primary="Leave Statement" />
            </ListItemButton>

            <ListItemButton component={NavLink} to="/leaves/approvals" sx={{ pl: 6 }}>
              <ListItemIcon sx={{ color: "inherit" }}>
                <EventAvailableIcon />
              </ListItemIcon>
              <ListItemText primary="Leave Approvals" />
            </ListItemButton>

            {canManageUsers(user?.role) && (
              <>
                <ListItemButton component={NavLink} to="/leaves/maintenance" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Leave Maintenance" />
                </ListItemButton>

                <ListItemButton component={NavLink} to="/leaves/holidays" sx={{ pl: 6 }}>
                  <ListItemIcon sx={{ color: "inherit" }}>
                    <CalendarMonthIcon />
                  </ListItemIcon>
                  <ListItemText primary="Holiday Calendar" />
                </ListItemButton>
              </>
            )}

          </List>

        </Collapse>

      </List>

    </Drawer>
  );
}